<template>
  <div class="market-currently-predicting">
    <div class="market-currently-predicting__title">{{ obj.title }}</div>
    <div class="market-currently-predicting__content" v-if="!!widget">
      <swiper v-bind="swiperOptions" :modules="swiperModules">
        <swiper-slide v-for="(pred, index) in traders" :key="index">
          <div class="market-currently-predicting__element">
            <div class="market-currently-predicting__user-area" @click.stop="showUserDetails(pred)">
              <div class="market-currently-predicting__avatar">
                <account-social-avatar
                  :avatar="pred.avatarImage"
                  :showProgress="true"
                  :percentage="100"
                  :progressStrokeColor="
                    getLevelByPredictions(pred.profitablePredictions).currentColor
                  "
                  :showEdit="false"
                  theme="markets"
                >
                </account-social-avatar>
              </div>
              <div class="market-currently-predicting__name">{{ pred.userName }}</div>
              <div class="market-currently-predicting__info">
                <div class="market-currently-predicting__active">
                  {{ traderLevelDisplay(pred) }}
                </div>
              </div>
            </div>
            <div class="market-currently-predicting__market" @click.stop="onClick(pred)">
              {{ pred.marketName }}
            </div>
            <div class="market-currently-predicting__footer">
              <div class="market-currently-predicting__wrap">
                <div class="market-currently-predicting__what">
                  {{ boughtSold(pred.tradeType) }}
                </div>
                <div :class="classModifier(pred.tradeType)">{{ yesNo(pred.tradeType) }}</div>
                <div class="market-currently-predicting__contract" v-if="!isMarketSingle(pred)">
                  <span>in</span> {{ pred.contractName }}
                </div>
                <div :class="priceClassModifiers(pred)">
                  <animated-number v-if="pred.pricePerShare" :value="Number(pred.pricePerShare)">
                  </animated-number>
                  <span v-else>&nbsp;</span>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script src="./market-currently-predicting.js"></script>
<style src="./market-currently-predicting.scss" lang="scss"></style>
